module.exports = __webpack_public_path__ + "img/icon-instagram.817c2474.svg";